// extracted by mini-css-extract-plugin
export var activityContainer = "_kl-0";
export var typingIndicatorContainer = "_kl-1";
export var typingIndicatorDot = "_kl-2";
export var wave = "_kl-3";